import classNames from 'classnames';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { InitiativeLink, InitiativePreviewLink } from '../../links/index.jsx';
import SentimentDot from '../../SentimentDot.jsx';
import styles from './StakeholderParticipationLabel.module.css';

const StakeholdersParticipationLabel = (props) => {
  const {
    isPreview,
    initiative,
    stakeholderParticipation,
    showCompletionDot,
    isActive,
    label,
  } = props;
  const [searchParams] = useSearchParams();
  const stakeholderParticipationId = stakeholderParticipation?.id;
  const Link = isPreview ? InitiativePreviewLink : InitiativeLink;
  const linkProps = {
    initiative,
    stakeholderParticipationId,
    initiativeParticipationId: searchParams.get('participant'),
    scroll: false,
  };

  const labelText = stakeholderParticipation
    ? `${stakeholderParticipation.name} (${stakeholderParticipation.children.length})`
    : label;

  return (
    <Link {...linkProps}>
      <a className={classNames({ 'text-active': isActive })}>
        <strong
          className={`${styles.strong} ${stakeholderParticipation?.archived ? 'text-muted' : ''}`}
        >
          {labelText}
        </strong>
        {showCompletionDot &&
          stakeholderParticipation &&
          stakeholderParticipation.leavesCompletedCount <
            stakeholderParticipation.leavesCount && (
            <SentimentDot outline sentiment="strongly_disagree" small />
          )}
      </a>
    </Link>
  );
};

StakeholdersParticipationLabel.defaultProps = {
  isActive: false,
  showCompletionDot: false,
  showSentimentDot: false,
  showOutlineBox: false,
};

export default StakeholdersParticipationLabel;
